(function () {

  var ARROW_STYLE = [
    'position: absolute',
    'top: 50%',
    'transform: translateY(-50%)',
    'z-index: 10',
    'background: rgba(255, 255, 255, 0.85)',
    'border: none',
    'border-radius: 50%',
    'width: 40px',
    'height: 40px',
    'display: flex',
    'align-items: center',
    'justify-content: center',
    'cursor: pointer',
    'box-shadow: 0 2px 8px rgba(0,0,0,0.15)',
    'pointer-events: all',
    'transition: background 0.2s, transform 0.2s'
  ].join(';');

  var CARET_SVG = '<svg width="10" height="10" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/>'
    + '</svg>';

  function createArrow(direction) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kw-gallery-arrow kw-gallery-arrow--' + direction;
    btn.setAttribute('aria-label', direction === 'prev' ? 'Previous image' : 'Next image');
    btn.setAttribute('style', ARROW_STYLE + ';' + (direction === 'prev' ? 'left:12px' : 'right:12px'));
    btn.innerHTML = CARET_SVG;
    btn.querySelector('svg').style.transform = direction === 'prev' ? 'rotate(90deg)' : 'rotate(-90deg)';
    btn.addEventListener('mouseenter', function () {
      btn.style.background = 'rgba(255,255,255,1)';
      btn.style.transform = 'translateY(-50%) scale(1.08)';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.background = 'rgba(255,255,255,0.85)';
      btn.style.transform = 'translateY(-50%) scale(1)';
    });
    return btn;
  }

  function initGalleryNav() {
    var mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery || typeof mediaGallery.setActiveMedia !== 'function') return;

    var sliderComp = mediaGallery.querySelector('slider-component');
    if (!sliderComp) return;

    // Clean up any previous arrows
    mediaGallery.querySelectorAll('.kw-gallery-arrow').forEach(function (el) { el.remove(); });

    if (window.getComputedStyle(sliderComp).position === 'static') {
      sliderComp.style.position = 'relative';
    }

    var prevBtn = createArrow('prev');
    var nextBtn = createArrow('next');
    sliderComp.appendChild(prevBtn);
    sliderComp.appendChild(nextBtn);

    // --- State ---
    var currentIndex = 0;
    var slides = []; // snapshot — stable, never rebuilt on click

    function snapshot() {
      // Take a fresh snapshot of visible slides (call only on init or variant change)
      slides = Array.from(
        mediaGallery.querySelectorAll('li.product__media-item')
      ).filter(function (li) { return li.style.display !== 'none'; });
      currentIndex = 0;
    }

    function goTo(rawIndex) {
      if (!slides.length) return;
      // Modulo looping: works for any number of images, any direction
      currentIndex = ((rawIndex % slides.length) + slides.length) % slides.length;
      var mediaId = slides[currentIndex].getAttribute('data-media-id');
      if (mediaId) mediaGallery.setActiveMedia(mediaId, true);
      // NOTE: do NOT call snapshot() here — Dawn reshuffles the DOM after
      // setActiveMedia which would corrupt our ordered list
    }

    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      goTo(currentIndex - 1);
    });

    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      goTo(currentIndex + 1);
    });

    // On variant change: re-snapshot with the new variant's images, reset to first
    function onVariantChange() {
      setTimeout(function () {
        snapshot();
        goTo(0);
      }, 150); // wait for variant-image-filter.js to hide/show slides first
    }

    var select = document.querySelector('variant-selects select');
    if (select) select.addEventListener('change', onVariantChange);
    document.querySelectorAll('variant-selects input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', onVariantChange);
    });
    document.addEventListener('variant:change', onVariantChange);

    // Hide on mobile
    var mq = window.matchMedia('(max-width: 749px)');
    function handleMQ(e) {
      var d = e.matches ? 'none' : 'flex';
      prevBtn.style.display = d;
      nextBtn.style.display = d;
    }
    mq.addEventListener ? mq.addEventListener('change', handleMQ) : mq.addListener(handleMQ);
    handleMQ(mq);

    // Initialise
    snapshot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryNav);
  } else {
    initGalleryNav();
  }

})();